import callAPI from '../../../API/callSecureAPI'
import endpoints from '../../../API/endpoints'
import { ValueNarrative } from './useGetValueNarrativesQuery'
import { useAuth0 } from '../../../contexts/auth0-context'
import { useMutation } from 'react-query'
import { useInvalidateGetValueNarrativesQuery } from './useInvalidateGetValueNarrativesQuery'
import { useInvalidateGetCommentsQuery } from '../../../shared/components/Comments/useCommentsQueries'
import { useSelector } from 'react-redux'

type UseArchiveValueNarrativeMutationProps = {
    onArchiveValueNarrative?: () => void
}

export const useArchiveValueNarrativeMutation = ({
    onArchiveValueNarrative,
}: UseArchiveValueNarrativeMutationProps) => {
    const { getTokenSilently } = useAuth0()

    // @ts-expect-error store is not typed properly
    const strategyId = useSelector((state) => state.strategy?._id)

    const { invalidateGetCommentsQuery } = useInvalidateGetCommentsQuery()

    const archiveValueNarrative = async (
        valueNarrative: Pick<ValueNarrative, '_id'> & { archived?: Pick<ValueNarrative['archived'], 'archivedNote'> }
    ) => {
        try {
            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const { url, method } = endpoints.archiveValueNarrative

            const postObject: Pick<ValueNarrative['archived'], 'archivedNote'> = {
                archivedNote: valueNarrative.archived?.archivedNote,
            }

            const response = await callAPI(url + valueNarrative._id, method, token, postObject)

            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    const { invalidateGetValueNarrativesQuery } = useInvalidateGetValueNarrativesQuery()

    return useMutation(archiveValueNarrative, {
        onSuccess: async (_, valueNarrative) => {
            await invalidateGetValueNarrativesQuery()
            invalidateGetCommentsQuery(valueNarrative._id)
            invalidateGetCommentsQuery(strategyId)
            onArchiveValueNarrative?.()
        },
    })
}
